import MonetaryFormatter from "../../helper/MonetaryFormatter";
import Vue from "vue";

const formatter = new MonetaryFormatter();

Vue.filter("currency", function(price, currency = App.activeCurrency)
{
    if (price === "N / A")
    {
        return price;
    }
    if (currency =="CHF")
    {
        price = Math.round(price*20, 0)/20;
        const format = (new Intl.NumberFormat("it-CH", {
            style: "currency",
            currency: "CHF"
        }).format(price));

        return format;
    }
    else
    {
        return formatter.format(parseFloat(price), currency);
    }
});
